"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictiveSearch = void 0;
var React = require("react");
require("core-js/es7/object");
var predictive_search_1 = require("@csod/predictive-search");
var PredictiveSearch = (function (_super) {
    __extends(PredictiveSearch, _super);
    function PredictiveSearch(props) {
        return _super.call(this, props) || this;
    }
    PredictiveSearch.prototype.render = function () {
        var _a = this.props, id = _a.id, value = _a.value, placeholder = _a.placeholder, minPredictLength = _a.minPredictLength, maxLength = _a.maxLength, errorMessage = _a.errorMessage, isEnabled = _a.isEnabled, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, isLoading = _a.isLoading, predictions = _a.predictions, noPredictionsMessage = _a.noPredictionsMessage, searchResultsPage = _a.searchResultsPage, debounceWait = _a.debounceWait, debounceMaxWait = _a.debounceMaxWait, iconName = _a.iconName, tag = _a.tag, changeQueryToSelectedOnSelect = _a.changeQueryToSelectedOnSelect, onChange = _a.onChange, onPredict = _a.onPredict, onSelect = _a.onSelect, onSearch = _a.onSearch;
        return React.createElement(predictive_search_1.PredictiveSearch, { id: id, value: value, placeholder: placeholder, minPredictLength: minPredictLength, maxLength: maxLength, errorMessage: errorMessage, isEnabled: isEnabled, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, isLoading: isLoading, predictions: predictions, noPredictionsMessage: noPredictionsMessage, searchResultsPage: searchResultsPage, debounceWait: debounceWait, debounceMaxWait: debounceMaxWait, iconName: iconName, tag: tag, changeQueryToSelectedOnSelect: changeQueryToSelectedOnSelect, onChange: onChange, onPredict: onPredict, onSelect: onSelect, onSearch: onSearch });
    };
    PredictiveSearch.defaultProps = {
        id: null,
        value: '',
        placeholder: null,
        minPredictLength: 2,
        maxLength: null,
        errorMessage: null,
        isEnabled: true,
        ariaLabel: null,
        ariaLabelledBy: null,
        isLoading: false,
        predictions: null,
        noPredictionsMessage: null,
        searchResultsPage: null,
        debounceWait: 500,
        debounceMaxWait: 3000,
        iconName: 'magnifying-glass',
        tag: null,
        changeQueryToSelectedOnSelect: true
    };
    return PredictiveSearch;
}(React.Component));
exports.PredictiveSearch = PredictiveSearch;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["PredictiveSearch"] = [];


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/.tmp/PredictiveSearch/PredictiveSearch.js
// module id = 810
// module chunks = 0